/**
 * Central label mapping — hides underlying Anthropic model IDs and
 * presents Cognara-branded engine names to end users. Used in the
 * Usage / Chat / Pricing / Studio / Analytics pages so no `claude-*`
 * string reaches the UI.
 *
 * Keep this in sync with backend `credits.MODEL_MULTIPLIERS` when
 * new engines ship.
 */
export const ENGINE_LABEL = {
  'claude-opus-4-8': 'Apex 4.8',
  'claude-opus-4-7': 'Ultra 4.7',
  'claude-opus-4-6': 'Pro 4.6',
  // Sonnet is used as the Emergent-proxy fallback engine (credit-outage,
  // rate-limit, etc.) — brand it as Standard so the ledger + charts
  // never expose the underlying vendor name.
  'claude-sonnet-4-6': 'Standard 4.6',
  'claude-sonnet-4-5': 'Standard 4.5',
  'claude-sonnet-4-20250514': 'Standard 4',
};

/** Full presentation name — used in dropdowns / tooltips. */
export const engineName = (id) => {
  if (!id) return '—';
  if (ENGINE_LABEL[id]) return `Cognara Engine · ${ENGINE_LABEL[id]}`;
  // Fallback for anything unmapped — strip provider prefixes so raw
  // vendor names never leak to the UI.
  return id
    .replace(/^anthropic\//i, '')
    .replace(/^claude-/i, 'Engine ')
    .replace(/-/g, ' ');
};

/** Short tier label — used inside chat bubbles / usage rows. */
export const engineTier = (id) => ENGINE_LABEL[id] || engineName(id);
